module.exports = __webpack_public_path__ + "static/media/Comment_Dark.6fd23e8b.svg";